import React from 'react';
import styled from 'styled-components';
import { typeHelpers } from '@polymathnetwork/new-shared';
import { Icon } from '~/components/Icon';

type IconProps = typeHelpers.GetProps<typeof Icon>;

export const IconCircled = styled(Icon)<IconProps>`
  border-radius: 50%;
`;

IconCircled.defaultProps = {
  ...Icon.defaultProps,
  bg: 'blue[0]',
  scale: 0.9,
};

// TODO @grsmto: remove when https://github.com/pedronauck/docz/issues/337 is resolved
export const IconCircledDocz = (props: IconProps) => {
  return <IconCircled {...props} />;
};
try {
    // @ts-ignore
    IconCircled.displayName = "IconCircled";
    // @ts-ignore
    IconCircled.__docgenInfo = { "description": "", "displayName": "IconCircled", "props": { "theme": { "defaultValue": null, "description": "", "name": "theme", "required": false, "type": { "name": "any" } }, "as": { "defaultValue": null, "description": "Typing Note: prefer using .withComponent for now as it is actually type-safe.\n\nString types need to be cast to themselves to become literal types (as={'a' as 'a'}).", "name": "as", "required": false, "type": { "name": "\"symbol\" | \"object\" | \"a\" | \"abbr\" | \"address\" | \"area\" | \"article\" | \"aside\" | \"audio\" | \"b\" | \"base\" | \"bdi\" | \"bdo\" | \"big\" | \"blockquote\" | \"body\" | \"br\" | \"button\" | \"canvas\" | ... 154 more ... | FunctionComponent<...>" } } } };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/IconCircled/IconCircled.tsx#IconCircled"] = { docgenInfo: IconCircled.__docgenInfo, name: "IconCircled", path: "src/components/IconCircled/IconCircled.tsx#IconCircled" };
}
catch (__react_docgen_typescript_loader_error) { }try {
    // @ts-ignore
    IconCircledDocz.displayName = "IconCircledDocz";
    // @ts-ignore
    IconCircledDocz.__docgenInfo = { "description": "", "displayName": "IconCircledDocz", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/IconCircled/IconCircled.tsx#IconCircledDocz"] = { docgenInfo: IconCircledDocz.__docgenInfo, name: "IconCircledDocz", path: "src/components/IconCircled/IconCircled.tsx#IconCircledDocz" };
}
catch (__react_docgen_typescript_loader_error) { }